import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';

const MagazineDetailsModal = ({ item }) => {
  return (
    <>
      <ModalHeader className="bg-primary text-white">
        Magazine Details
      </ModalHeader>
      <ModalBody>
        <div className="p-4">
          <div className="row">
            <div className="col-md-12">
              <h4 className="text-primary mb-4">
                {item?.pdfName}
              </h4>
              <div className="mb-4">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-eye me-2"></i>
                  <strong>Views: </strong> &nbsp;
                  {item?.viewCount || 0}
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-calendar-event me-2"></i>
                  <strong>Created Date: </strong> &nbsp;
                  {moment(item?.createdAt).format("DD-MM-YYYY")}
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-file-pdf me-2"></i>
                  <strong>PDF URL: </strong> &nbsp;
                  <a
                    href={`${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${item?.pdfUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-2"
                  >
                    View PDF
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
};

export default MagazineDetailsModal; 